import {FETCH_POST_ORDER,FETCH_ERROR, FETCH_LOADING} from '../types/types'


const initialState = {
    delivery:{},
    cartItems: [],
    Errors:"",
    TotalPrice:0,
    orderOk:false,
    Loading:false
}

export const orderReducer = (state = initialState,action)=>{
    switch(action.type){
        case FETCH_POST_ORDER:
            return{
                ...state,Loading:false,delivery:action.payload.delivery,cartItems:action.payload.orderItems,TotalPrice:action.payload.TotalPrice,orderOk:true
            }
        case FETCH_LOADING:
            return{
                ...state,Loading:true
            }
        case FETCH_ERROR:
            return{
                ...state,Errors:action.payload
            }    
            default:
                return state;
    }
}